<template>
  <div>
    <div v-if="isEditing">
      <input
        :key="editing"
        type="textarea"
        v-focus
        size="mini"
        v-model="property.vehicle.patent"
        @keyup.enter="onChangePatent"
        @keyup.esc="onCancelPatent"
        @blur="onChangePatent">
    </div>
    <template v-else>
      <el-link @click="onClickCell">
        <i v-if="loading" class="el-icon-loading"></i>
        <i v-else class="el-icon-truck"></i>
      </el-link>
      <span style="margin-left: 5px; font-size: 10px;">
        {{property.vehicle.patent}}</span>
    </template>
  </div>
</template>

<script>
import { apiRequest } from '../../backend/vue-axios/axios';

const focus = {
  inserted(el) {
    el.focus();
  },
};

export default {
  name: 'EditableTruck',
  props: ['scope', 'editing', 'on-blur', 'on-enter', 'property', 'subproperty'],
  data() {
    return {
      isEditing: false,
      oldValue: null,
      loading: false,
    };
  },
  methods: {
    onClickCell() {
      this.isEditing = true;
      this.oldValue = this.property.vehicle.patent;
    },
    onChangePatent() {
      if (this.isEditing) {
        if (this.validate()) {
          if (this.oldValue === this.property.vehicle.patent) {
            this.isEditing = false;
          } else {
            const parameters = {
              patent: this.property.vehicle.patent.toUpperCase(),
            };
            this.loading = true;
            apiRequest(
              {
                module: 'planning',
                service: 'set_vehicle_on_routev2',
                pathparam: { id: this.property.id },
                params: parameters,
              },
            ).then(() => {
              this.$notify({
                type: 'success',
                title: 'OK',
                message: 'Patente modificada',
              });
              this.$emit('refresh');
              this.loading = false;
            }).catch((error) => {
              if (error.response) {
                let messageErr = '';
                if (error.response.data.message === 'record not found') {
                  messageErr = 'Registro no encontrado';
                } else if (error.response.data.message === 'The vehicle does not exists') {
                  messageErr = `Patente ${this.property.vehicle.patent} no existe`;
                } else if (error.response.data.message === 'The same vehicle') {
                  messageErr = `Patente ${this.property.vehicle.patent} ya tiene esta ruta asignada`;
                } else if (error.response.data.message === 'The vehicle can not be modified, the route is active') {
                  messageErr = 'No se puede modificar patente si la ruta esta activa';
                }
                if (messageErr === '') {
                  this.$notify({
                    type: 'error',
                    title: 'Error',
                    message: error.response.data.message,
                  });
                } else {
                  this.$notify({
                    type: 'error',
                    title: 'Error',
                    message: messageErr,
                  });
                }
              }
              this.loading = false;
              this.property.vehicle.patent = this.oldValue;
            });
            this.isEditing = false;
          }
        } else {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'El formato de la patente no es valida',
          });
          this.property.vehicle.patent = this.oldValue;
          this.isEditing = false;
        }
      }
    },
    validate() {
      const patent = this.property.vehicle.patent.toUpperCase();
      if (/^([A-Z]{4}-[0-9]{2})|([A-Z]{2}-[0-9]{4})|([A-Z]{3}-[0-9]{3})/.test(patent)) {
        return true;
      }
      if (/^([A-Z]{4}[0-9]{2})/.test(patent)) {
        this.property.vehicle.patent = `${patent.substring(0, 4)}-${patent.substring(4, 7)}`;
        return true;
      }
      if (/^([A-Z]{2}[0-9]{4})/.test(patent)) {
        this.property.vehicle.patent = `${patent.substring(0, 2)}-${patent.substring(2, 7)}`;
        return true;
      }
      if (/^([A-Z]{3}[0-9]{3})/.test(patent)) {
        this.property.vehicle.patent = `${patent.substring(0, 3)}-${patent.substring(3, 7)}`;
        return true;
      }
      return false;
    },
    onCancelPatent() {
      this.property.vehicle.patent = this.oldValue;
      this.isEditing = false;
    },
  },
  directives: { focus },
};

</script>
<style lang="scss" scoped>
  .el-icon-truck{
    font-size: 20px;
    color: #AAD500;
    font-weight: 400;
  }
  .el-icon-loading{
    font-size: 20px;
    color: #AAD500;
    font-weight: 400;
  }
  .el-icon-edit:focus{
    outline: none !important;
    text-decoration-line: none !important;
  }
  i:hover {
    text-decoration: none;
    text-decoration-line: none !important;
  }
  input:focus{
    outline: none;
    color: #AAD500;
    width: 70px;
    text-decoration-line: none !important;
  }
  .el-link{
    text-decoration-line: none !important;
    text-decoration: none !important;
  }
</style>
